import React, { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { getPagePartSlug } from '@gov-nx/module/page/definitions/PageMap';
import AuthorizedRoute from '../../routes/AuthorizedRoute';

const CadastreOfRealEstatePage = lazy(() =>
	import('./CadastreOfRealEstatePage').then(({ CadastreOfRealEstatePage }) => ({
		default: CadastreOfRealEstatePage,
	}))
);

export const getCadastreRoutes = (): RouteObject[] => [
	{
		path: getPagePartSlug('muj-katastr-nemovitosti'),
		element: (
			<AuthorizedRoute>
				<CadastreOfRealEstatePage />
			</AuthorizedRoute>
		),
	},
];
